/** Schedule A go-live checklist: platform costs live → cost templates → approve & activate. */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Circle } from 'lucide-react';
import api from '../../lib/api';
import { Card, StatusPill } from '../finance/financeUi';

const PLATFORM_STATUS = { LIVE: 'ACTIVE', WAITING_APPROVAL: 'PENDING', NOT_SET: 'NOT_SET' };

export function GoLiveCard({ refreshKey, partnerType = 'sales_agent' }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.request(`/admin/schedule-a/go-live?partner_type=${partnerType}`).then(setD).catch(() => setD(null)); }, [refreshKey, partnerType]);
  if (!d) return null;
  return (
    <Card title="Go-live checklist" testid="go-live-card" aside={<StatusPill value={d.ready ? 'ACTIVE' : 'PENDING'} testid="go-live-status" />}>
      <ol className="divide-y px-5">
        {d.steps.map((s, i) => (
          <li key={s.key} className="flex flex-wrap items-center justify-between gap-2 py-3 text-sm" data-testid={`go-live-step-${s.key}`}>
            <span className="flex items-center gap-2">
              {s.done ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <Circle className="h-4 w-4 text-muted-foreground" />}
              <span className={s.done ? 'text-muted-foreground line-through' : ''}>{i + 1}. {s.label}</span>
              {s.optional && <span className="text-xs text-muted-foreground">(optional)</span>}
            </span>
            {!s.done && s.link && <Link to={s.link} className="text-xs font-medium text-primary underline-offset-2 hover:underline" data-testid={`go-live-link-${s.key}`}>Open</Link>}
          </li>
        ))}
      </ol>
      <div className="flex flex-wrap gap-2 border-t px-5 py-3 text-xs text-muted-foreground" data-testid="go-live-platforms">
        {d.platforms.map((p) => <span key={p.platform} className="flex items-center gap-1">{p.platform} <StatusPill value={PLATFORM_STATUS[p.status]} /></span>)}
        <span className="ml-auto">{d.templates} templates · {d.assigned}/{d.agents} agents assigned</span>
      </div>
    </Card>
  );
}
